
import axios from '../../helpers/private.axios'

export const getSingleDocument = ( id ) => {
    return axios.get(`/api/documents/doc/${id}`);
}